import { Box, OSKThemeType, Text } from 'oskcomponents';
import React from 'react';
import { useTheme } from 'styled-components';
import { BasicDialog } from '~/molecules/BasicDialog';

export type InviteUserAttributes = {
    [key: string]: any;
};

export type InviteUserDialogProps = {
    visible: boolean;
    email: string;
    onCancel?: () => void;
    onSubmit?: (data: InviteUserAttributes) => void;
};

export const InviteUserDialog = ({ email, onCancel, onSubmit, visible }: InviteUserDialogProps) => {
    const theme = useTheme() as OSKThemeType;

    return (
        <BasicDialog cancel onCancel={onCancel} onSubmit={onSubmit} visible={visible} title="Invite User">
            <Box style={{ textAlign: 'center' }} col>
                <Text color={theme.colors.black900}>Confirm you would like to invite the user:</Text>
                <Text color={theme.colors.black900} variant="large">
                    {email}
                </Text>
            </Box>
        </BasicDialog>
    );
};
